import React from "react";
import OurStory from "../Components/About/OurStory.component";
import Sidebar from "../Components/RightSideBar/Sidebar";
import Engage from "../Components/Engage/Engage.component";
import GauSevak from "../Components/GauSevak/GauSevak.component";
import Hero from "../Components/Hero/Hero.component";
import Services from "../Components/ServicesSection/Services.component";
import Testimonials from "../Components/Testimonials/Testimonials.component";
import VideoGallery from "../Components/VideoGallery/VideoGallery.component";
import Footer from "../Components/Footer/Footer.component";
import Contact from "../Components/Contact/Contact.component";

function HomePage() {
  
  return (
    <>
      <Hero />
      <Sidebar />
      <OurStory />
      <Services />
      <Engage />
      <VideoGallery />
      <Testimonials />
      <GauSevak />
      <Contact />
      <Footer />
    </>
  );
}

export default HomePage;
